const OriginalSchedulesMenu = 'original';
const NewSchedulesMenu  ='new';

export { OriginalSchedulesMenu, NewSchedulesMenu };
